import { render, staticRenderFns } from "./CadastroEmitente.vue?vue&type=template&id=0783fb3a&scoped=true"
import script from "./CadastroEmitente.vue?vue&type=script&lang=js"
export * from "./CadastroEmitente.vue?vue&type=script&lang=js"
import style0 from "./CadastroEmitente.vue?vue&type=style&index=0&id=0783fb3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0783fb3a",
  null
  
)

export default component.exports